import React, { Component } from "react";
import intl from "react-intl-universal";

const Footer = () => {
  return (
    <footer className="footer fixed-bottom">
      <div className="container text-center">
        <span className="navbar-text col-md-12 col-sm-12 col-xs-12">
          © {new Date().getFullYear()} {intl.get("StatusBar_Copyright")} | <a  href="https://www.skylinesoft.com/privacy-policy" target="_blank" > Privacy Policy  </a>  | <a  href="https://www.skylinesoft.com/technical-support" target="_blank" > Support  </a> |  {process.env.REACT_APP_SG_CLOUD_VERSION}
        </span>
      </div>
    </footer>
  );
};

export default Footer;
